import wrapper from 'wrapper';
import events from './events-emitter';

class Observer {
    constructor() {
        const iframeContainers = [].slice.call(wrapper.selectAll('.ns-pym-iframe-container'));
        if ('IntersectionObserver' in window) {
            const config = {
                root: null,
                rootMargin: '0px',
                // eslint-disable-next-line max-len
                threshold: 0.85, // A threshold of 1.0 means that when 100% of the target is visible within the element specified by the root option, the callback is invoked. https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
            };
            this.iframeContainersObserver = new IntersectionObserver(this.onChange.bind(this), config);

            // Loop through and observe each image
            iframeContainers.forEach((iframeContainer) => {
                this.iframeContainersObserver.observe(iframeContainer);
            });
        }
        else {
            iframeContainers.forEach((iframeContainer) => {
                /* eslint-disable no-param-reassign */
                iframeContainer.classList.remove('iframeContainer');
            });
        }
    }

    onChange(entries) {
        entries.forEach((entry) => {
            const iframeContainer = entry.target;
            if (entry.isIntersecting) {
                events.emit('inView', {
                    el: iframeContainer,
                });
                this.iframeContainersObserver.unobserve(iframeContainer);
            }
        });
    }
}

export default Observer;
